__turbopack_context__.v({
  "popup": "PopupShell-module-sass-module__uoAC_W__popup",
  "wrapper": "PopupShell-module-sass-module__uoAC_W__wrapper",
});
